import { mapGetters } from "vuex";

export default {
    data() {
        return {
            column1Items: [],
            column2Items: [],
            appConfig: window.appConfig,
        };
    },
    computed: {
        ...mapGetters({
            destinations: "GET_DESTINATION_CARDS" 

        }),
        footerHidden() {
            return this.$store.state.ui.footerHidden;
        },
        logo() {
            return this.appConfig === 'avm' ? '/img/logo-ahora-vuelvo-mama.svg' : '/img/logo-ebm.svg';
        }
    },
    watch: {
        destinations: {
            immediate: true,
            handler(destinations) {
                if (destinations.length > 0) {
                    this.setFooterItems(destinations);
                }
            }
        }
    },
    methods: {
        setFooterItems(destinations) {
            const destinies = destinations.map(destiny => ({
                id: destiny.id,
                label: destiny.title,
                url: destiny.link,
            }));

            const helpItem = {
                id: 4,
                label: this.$t('shared.help'),
                url: "/ayuda",
                onClick: () => this.navigateToHelp()
            };

            if (this.appConfig === 'avm') {
                this.column1Items = [
                    ...destinies,
                    { id: 5, label: this.$t('shared.give_away_avm').replace(/<[^>]+>/g, ''), url: "/regala" },
                    { id: 6, label: this.$t('shared.avm_about'), url: "/ayuda" },
                    { id: 7, label: this.$t('shared.avm_cupon'), url: "/terminos-y-condiciones-cupones" },
                    { id: 8, label: this.$t('shared.avm_flexi'), url: "/terminos-y-condiciones-flex" },
                ];

                this.column2Items = [
                    { id: 9, label: this.$t('shared.reserve_area'), url: "/area-reserva/portal" },
                    { id: 10, label: this.$t('shared.blog'), url: "/blog" },
                    { id: 11, label: this.$t('shared.contact'), url: "/contacto" },
                    helpItem
                ];
            } else if (this.appConfig === 'ebm') {
                this.column1Items = destinies;
                this.column2Items = [
                    { id: 12, label: this.$t('shared.reserve_area'), url: "/area-reserva/portal" },
                    { id: 13, label: this.$t('shared.contact'), url: "/contacto" },
                    helpItem,
                    { id: 14, label: this.$t('shared.blog'), url: "/blog" },
                ];
            }
        },
        navigateToHelp() {
            const currentRoute = this.$router.currentRoute;
            const targetRoute = { name: 'help', params: { tab: 1 } };

            if (currentRoute.name === 'help') {
                this.$router.replace(targetRoute);
                this.scrollToTop();
            } else {
                this.$router.push(targetRoute);
            }
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
};
